import { store } from '../../app';

export const getSettings = () => {
  return store.getState().settings;
};
